<template>
  <AppLayout>
    <div class="transaction fleet-module-page">
      <section class="container">
        <div class="fleet-stat-grid">
          <div class="fleet-stat-card"><span>Total Drivers</span><strong>{{ driverStats?.total || 0 }}</strong></div>
          <div class="fleet-stat-card"><span>Valid Licences</span><strong>{{ driverStats?.valid || 0 }}</strong></div>
          <div class="fleet-stat-card"><span>Expiring Soon</span><strong>{{ driverStats?.expiring || 0 }}</strong></div>
          <div class="fleet-stat-card"><span>Linked Users</span><strong>{{ driverStats?.linked || 0 }}</strong></div>
        </div>

        <div class="filter-search">
          <div class="filter-search-header"><p>Filter</p></div>
          <div class="filter-search-content">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Search</label>
                  <input
                    :value="filters?.search || ''"
                    class="form-control"
                    placeholder="Driver, phone or licence..."
                    @input="setFilter('search', $event.target.value)"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Licence Status</label>
                  <select
                    :value="filters?.licenseState || ''"
                    class="form-control"
                    @change="setFilter('licenseState', $event.target.value)"
                  >
                    <option value="">All</option>
                    <option value="VALID">Valid</option>
                    <option value="EXPIRING">Expiring Soon</option>
                    <option value="EXPIRED">Expired</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-toolbar">
              <button class="btn btn-style-2 btn-sm" @click="openCreateModal">Add Driver</button>
        </div>
        <div class="data-table-wrapper">
          <div class="table-wrap">
            <table ref="fleetTable" class="fleet-table table table-hover">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Name</th>
                  <th>Licence Number</th>
                  <th>Phone</th>
                  <th>Linked User</th>
                  <th>Expiry</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, index) in filteredDrivers" :key="d.id || d.driver_id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ d.name || d?.user?.name || '-' }}</td>
                  <td>{{ d.licenseNumber || '-' }}</td>
                  <td>{{ d.phone || '-' }}</td>
                  <td>{{ d?.user?.name || d?.user?.email || '-' }}</td>
                  <td>{{ formatDate(d.licenseExpiry) }}</td>
                  <td>
                    <span class="status-pill" :class="statusClass(getLicenseStatus(d))">{{ getLicenseStatus(d) }}</span>
                  </td>
                  <td>
                    <div class="table-actions">
                      <button class="mini-btn" @click="startEdit(d)">Edit</button>
                      <button class="mini-btn danger" @click="removeDriver(d)">Delete</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="showModal" class="svc-modal-overlay" @click.self="closeModal">
          <div class="svc-modal-box">
            <div class="svc-modal-header">
              <h6 class="fw-bold mb-0">{{ editId ? 'Edit Driver' : 'Add Driver' }}</h6>
              <button class="btn-close-plain" @click="closeModal">&times;</button>
            </div>
            <div class="svc-modal-body">
              <div class="row g-2">
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">Driver Name</label>
                  <input
                    v-model="form.name"
                    class="form-control form-control-sm"
                    :readonly="form.user_id"
                  />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">Phone</label>
                  <input v-model="form.phone" class="form-control form-control-sm" />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">Licence Number</label>
                  <input v-model="form.licenseNumber" class="form-control form-control-sm" />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">Licence Expiry</label>
                  <input v-model="form.licenseExpiry" type="date" class="form-control form-control-sm" />
                </div>
                <div class="col-12">
                  <label class="form-label" style="font-size:11px;">Linked User</label>
                  <select v-model.number="form.user_id" class="form-control form-control-sm" @change="onUserChange">
                    <option :value="null">Select user</option>
                    <option v-for="u in users" :key="u.id" :value="u.id">{{ u.name || u.email || `User ${u.id}` }}</option>
                  </select>
                    onUserChange() {
                      const selected = this.users.find(u => u.id === this.form.user_id);
                      if (selected) {
                        this.form.name = selected.name || selected.email || '';
                      } else {
                        this.form.name = '';
                      }
                    },
                </div>
              </div>
              <p v-if="errorMessage" class="text-danger small mt-2">{{ errorMessage }}</p>
            </div>
            <div class="svc-modal-footer">
              <button class="btn btn-sm btn-style-2" @click="closeModal">Cancel</button>
              <button class="btn btn-sm btn-primary" @click="saveDriver" :disabled="saving">
                <span v-if="saving"><i class="fas fa-spinner fa-spin me-1"></i>Saving...</span>
                <span v-else>{{ editId ? 'Update Driver' : 'Save Driver' }}</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from '@/components/AppLayout.vue';
import fleetApi from '@/api/fleet';
import Swal from '@/utils/swal';
import 'datatables.net-vue3';
import 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-responsive-bs5';
import $ from 'jquery';
import 'jszip';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.print.js';

function emptyForm() {
  return {
    name: '',
    licenseNumber: '',
    licenseExpiry: '',
    phone: '',
    user_id: null,
  };
}

export default {
  name: 'FleetDrivers',
  components: { AppLayout },
  data() {
    return {
      drivers: [],
      users: [],
      dataTable: null,
      showModal: false,
      editId: null,
      saving: false,
      errorMessage: '',
      filters: {
        search: '',
        licenseState: '',
      },
      form: emptyForm(),
    };
  },
  computed: {
    filteredDrivers() {
      const filters = this.filters || this.getDefaultFilters();
      const q = String(filters.search || '').toLowerCase().trim();
      return (this.drivers || []).filter((d) => {
        const text = [d.name, d.phone, d.licenseNumber, d?.user?.name, d?.user?.email].filter(Boolean).join(' ').toLowerCase();
        const status = this.getLicenseStatus(d);
        const matchesSearch = !q || text.includes(q);
        const matchesState = !filters.licenseState || status === filters.licenseState;
        return matchesSearch && matchesState;
      });
    },
    driverStats() {
      const items = Array.isArray(this.drivers) ? this.drivers : [];
      const valid = items.filter((d) => this.getLicenseStatus(d) === 'VALID').length;
      const expiring = items.filter((d) => this.getLicenseStatus(d) === 'EXPIRING').length;
      const linked = items.filter((d) => d?.user || d?.user_id || d?.userId).length;
      return { total: items.length, valid, expiring, linked };
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        if (!this.filters) {
          this.filters = this.getDefaultFilters();
        }
        this.initializeDataTable();
      },
    },
  },
  methods: {
    getDefaultFilters() {
      return {
        search: '',
        licenseState: '',
      };
    },
    setFilter(key, value) {
      const current = this.filters || this.getDefaultFilters();
      this.filters = { ...current, [key]: value };
    },
    destroyDataTable() {
      if (this.dataTable && typeof this.dataTable.destroy === 'function') {
        this.dataTable.destroy();
        this.dataTable = null;
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        const tableElement = this.$refs.fleetTable;
        if (!tableElement) return;
        this.destroyDataTable();
        this.dataTable = $(tableElement).DataTable({
          responsive: true,
          destroy: true,
          pageLength: 10,
          lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, 'All']],
          language: {
            emptyTable: 'No drivers found',
            paginate: {
              previous: '<i class="fa fa-chevron-left"></i>',
              next: '<i class="fa fa-chevron-right"></i>',
            },
          },
          dom: 'Bfrtip',
          buttons: [
            'colvis',
            'pageLength',
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-sm btn-outline-primary',
              exportOptions: { columns: ':visible' },
            },
          ],
        });
      });
    },
    notifyError(err) {
      this.$toast?.error?.(err?.message || 'Request failed');
    },
    formatDate(v) {
      if (!v) return '-';
      const d = new Date(v);
      return Number.isNaN(d.getTime()) ? '-' : d.toLocaleDateString();
    },
    getLicenseStatus(driver) {
      if (!driver?.licenseExpiry) return 'VALID';
      const expiry = new Date(driver.licenseExpiry).getTime();
      const now = Date.now();
      const days = Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));
      if (days < 0) return 'EXPIRED';
      if (days <= 30) return 'EXPIRING';
      return 'VALID';
    },
    statusClass(status) {
      if (status === 'VALID') return 'status-valid';
      if (status === 'EXPIRING') return 'status-expiring';
      if (status === 'EXPIRED') return 'status-expired';
      return 'status-default';
    },
    async loadData() {
      try {
        const [driversRes, usersRes] = await Promise.all([
          fleetApi.listDrivers({ page: 1, limit: 200 }),
          fleetApi.listUsers(),
        ]);
        this.drivers = fleetApi.unwrapList(driversRes);
        this.users = fleetApi.unwrapList(usersRes);
        this.initializeDataTable();
      } catch (err) {
        this.notifyError(err);
      }
    },
    openCreateModal() {
      this.editId = null;
      this.form = emptyForm();
      this.errorMessage = '';
      this.showModal = true;
    },
    startEdit(d) {
      this.editId = d.id || d.driver_id;
      this.form = {
        name: d.name || d?.user?.name || '',
        licenseNumber: d.licenseNumber || '',
        licenseExpiry: d.licenseExpiry ? String(d.licenseExpiry).slice(0, 10) : '',
        phone: d.phone || '',
        user_id: d.user_id || d.userId || d?.user?.id || null,
      };
      this.errorMessage = '';
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.editId = null;
      this.form = emptyForm();
      this.errorMessage = '';
    },
    async saveDriver() {
      if (!this.form.licenseNumber || !this.form.licenseExpiry || !this.form.user_id) {
        this.errorMessage = 'Licence number, expiry date and linked user are required.';
        return;
      }

      this.saving = true;
      try {
        if (this.editId) {
          await fleetApi.updateDriver(this.editId, this.form);
          this.$toast?.success?.('Driver updated');
        } else {
          await fleetApi.createDriver(this.form);
          this.$toast?.success?.('Driver created');
        }
        this.closeModal();
        await this.loadData();
      } catch (err) {
        this.notifyError(err);
      } finally {
        this.saving = false;
      }
    },
    async removeDriver(d) {
      const id = d.id || d.driver_id;
      if (!id) return;
      const result = await Swal.fire({
        title: `Delete driver ${d.licenseNumber}?`,
        text: 'This action cannot be undone!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      });
      if (!result.isConfirmed) return;
      try {
        await fleetApi.deleteDriver(id);
        this.$toast?.success?.('Driver deleted');
        await this.loadData();
      } catch (err) {
        this.notifyError(err);
      }
    },
  },
  mounted() {
    if (!this.filters) {
      this.filters = this.getDefaultFilters();
    }
    this.loadData();
  },
  beforeUnmount() {
    this.destroyDataTable();
  },
};
</script>

<style scoped>
@import './fleet.shared.css';
</style>
